import React, { useState, useEffect } from "react";
import "@/App.css";
import { Toaster } from "./components/ui/sonner";
import LoadingScreen from "./components/LoadingScreen";
import HeroSection from "./components/HeroSection";
import ServicesSection from "./components/ServicesSection";
import WhyChooseSection from "./components/WhyChooseSection";
import StatsSection from "./components/StatsSection";
import ContactSection from "./components/ContactSection";
import FloatingButtons from "./components/FloatingButtons";
import Footer from "./components/Footer";

function App() {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Set page title
    document.title = "Doon Auto Glass | 24/7 Car Windshield Repair in Dehradun";
    
    // Add meta description for SEO
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Doon Auto Glass - Professional 24/7 car windshield repair and replacement services in Dehradun. 4+ years experience, 5-star rated. Call +91 7300677651');
    } else {
      const meta = document.createElement('meta');
      meta.name = 'description';
      meta.content = 'Doon Auto Glass - Professional 24/7 car windshield repair and replacement services in Dehradun. 4+ years experience, 5-star rated. Call +91 7300677651';
      document.head.appendChild(meta);
    }
  }, []);

  return (
    <div className="App min-h-screen bg-[#050505]" data-testid="app-container">
      {/* Loading screen */}
      {isLoading && (
        <LoadingScreen onComplete={() => setIsLoading(false)} />
      )}
      
      {/* Main content */}
      <main className={`transition-opacity duration-500 ${isLoading ? 'opacity-0' : 'opacity-100'}`}>
        {/* Hero Section with 3D Car */}
        <HeroSection />
        
        {/* Services Section */}
        <ServicesSection />
        
        {/* Stats Section */}
        <StatsSection />
        
        {/* Why Choose Us Section */}
        <WhyChooseSection />
        
        {/* Contact Section */}
        <ContactSection />
        
        {/* Footer */}
        <Footer />
      </main>
      
      {/* Floating CTA Buttons */}
      {!isLoading && <FloatingButtons />}
      
      {/* Toast notifications */}
      <Toaster 
        position="top-right"
        toastOptions={{
          style: {
            background: '#121212',
            border: '1px solid rgba(255,255,255,0.1)',
            color: '#fff'
          }
        }}
      />
    </div>
  );
}

export default App;
